import {
  type OnInit,
  type OnDestroy,
  Component,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import * as tablerIcons from '@ng-icons/tabler-icons';
import * as tablerIconsFill from '@ng-icons/tabler-icons/fill';
import * as lucideIcons from '@ng-icons/lucide';
import { provideIcons } from '@ng-icons/core';
import type { Subscription } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  viewProviders: [provideIcons({ ...tablerIcons, ...tablerIconsFill, ...lucideIcons })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private titleService = inject(Title);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private routerEventsSub?: Subscription;

  ngOnInit(): void {
    this.routerEventsSub = this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild != null) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data),
      )
      .subscribe((data) => {
        const title = (data as { title?: string }).title;
        if (title != null && title !== '') {
          this.titleService.setTitle(
            `${title} | Admin Panel - Manage Merchants and System Transactions`,
          );
        }
      });
  }

  ngOnDestroy(): void {
    this.routerEventsSub?.unsubscribe();
  }
}
